export const TRAFFIC_ANALYSIS_STATS_API_PATHNAMES = {
  TRAFFIC_ANALYSIS_STATS_DATA: ({ startDate, endDate }) =>
    `host/affliate/statistics?start_date=${startDate}&end_date=${endDate}`,
};
